import { Card, Group, Progress, Stack, Text } from '@mantine/core';
import { AccountUtils } from '../../AccountUtils';

interface UsageSummaryCardsProps {
  storageBytesUsed: number;
  storageBytesLimit: number | null;
  transferBytesUsed: number;
  transferBytesLimit: number | null;
}

export function UsageSummaryCards({
  storageBytesUsed,
  storageBytesLimit,
  transferBytesUsed,
  transferBytesLimit,
}: UsageSummaryCardsProps) {
  return (
    <Group grow align="stretch">
      <UsageCard
        title="Storage"
        bytesUsed={storageBytesUsed}
        bytesLimit={storageBytesLimit}
      />
      <UsageCard
        title="Data Transfer"
        bytesUsed={transferBytesUsed}
        bytesLimit={transferBytesLimit}
      />
    </Group>
  );
}

function UsageCard({
  title,
  bytesUsed,
  bytesLimit,
}: {
  title: string;
  bytesUsed: number;
  bytesLimit: number | null;
}) {
  const percent = AccountUtils.usagePercent(bytesUsed, bytesLimit);
  const color = percent !== null ? AccountUtils.usageColor(percent) : 'blue';
  const usedLabel = AccountUtils.formatBytesAsGB(bytesUsed);
  const limitLabel = bytesLimit !== null ? AccountUtils.formatBytesAsGB(bytesLimit) : null;

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Stack gap="sm">
        <Text fw={600} size="md">{title}</Text>

        {percent !== null ? (
          <>
            <Progress value={percent} color={color} size="lg" radius="md" aria-label={`${title} usage: ${Math.round(percent)}%`} />
            <Group justify="space-between">
              <Text size="sm" fw={500}>
                {usedLabel} / {limitLabel}
              </Text>
              <Text size="sm" c="dimmed">
                {Math.round(percent)}%
              </Text>
            </Group>
          </>
        ) : (
          // No known limit — show usage only; don't imply "Unlimited".
          <Text size="sm" fw={500}>{usedLabel}</Text>
        )}
      </Stack>
    </Card>
  );
}
